import React from "react";
import PropTypes from 'prop-types';
import { VStack } from "~/native-ui/native-base";

const propTypes = {
  fluid: PropTypes.bool,
  children: PropTypes.node
};

const Container = React.memo(({ w="100%", space="4", ...props }) => {
    return <VStack { ...props } w={w} space={space} />
});

export const Grid = React.memo(Container)

Grid.propTypes = propTypes;
